import { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import CommonContext from "context/CommonContext";
import { Grid, InputAdornment, IconButton } from "@mui/material";
import FormTextField from "components/utils/CustomFields/FormTextField";
import { ROUTES, STORAGE_KEYS, CONTACT_NUMBER, SYSTEM_VIEW, KEYBOARD_KEYS } from "const";
import * as TerminalHelper from "helpers/TermialHelper";
import styles from "./styles.module.css";
import Button from "@mui/material/Button";
import WalletIcon from "@mui/icons-material/Wallet";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Loader from "components/utils/Loading/index";
import AuthService from "services/AuthService";
import toast from "react-hot-toast";
import UserHelper from "helpers/UserHelper";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { platform } = useContext(CommonContext);
  const navigate = useNavigate();
  const passwordRef = useRef(null);
  const usernameRef = useRef(null);

  useEffect(() => {
    if (usernameRef.current) {
      usernameRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const nextBillNumber = localStorage.getItem(STORAGE_KEYS.BILL_NUMBER_SUFFIX);
    const shop = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
    const counter = localStorage.getItem(STORAGE_KEYS.COUNTER);
    const shift = localStorage.getItem(STORAGE_KEYS.SHIFT);

    const terminalSettings = TerminalHelper.getTerminalSettings();
    const systemType = terminalSettings.systemType;

    if (UserHelper.isLoggedIn() && shop && counter && nextBillNumber && shift) {
      if (systemType === SYSTEM_VIEW.ERP) {
        navigate(ROUTES.ERP_DASHBOARD);
      } else {
        navigate(ROUTES.SALES);
      }
    } else if (UserHelper.isLoggedIn() && shop && counter && nextBillNumber) {
      navigate(ROUTES.SHIFT);
    } else if (UserHelper.isLoggedIn() && shop && counter) {
      navigate(ROUTES.BILL_NUMBER);
    } else if (UserHelper.isLoggedIn() && shop) {
      navigate(ROUTES.COUNTER);
    } else if (UserHelper.isLoggedIn()) {
      navigate(ROUTES.SELECT_SHOP);
    }
    //eslint-disable-next-line
  }, []);

  const onClickLoginButton = async (_e) => {
    if (!username || !password) {
      toast.error("Username and Password should not be empty..");
      return;
    }
    setIsLoading(true);
    const error = await AuthService.login(username, password);
    setIsLoading(false);
    if (error) {
      toast.error("Failed to login!");
    } else {
      navigate(ROUTES.SELECT_SHOP);
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <>
      <Loader isOpen={isLoading} />
      <Grid container rowSpacing={5} className={styles.textArea}>
        <Grid item xs={12}>
          <Grid container rowSpacing={1}>
            <Grid item xs={12} display="flex" justifyContent={"center"}>
              <span className={styles.head1}>Sanoft</span>
              <span className={styles.head2}>POS</span>
            </Grid>
            <Grid item xs={12} className={styles.text}>
              <span>Please provide your login details to access your account and enjoy a seamless experience</span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "24px" }}>
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <FormTextField
                id="outlined-basic"
                label="Username"
                value={username || ""}
                onChange={(e) => setUsername(e.target.value)}
                inputRef={usernameRef}
                onKeyDown={(e) => {
                  if (e.key === KEYBOARD_KEYS.ENTER) {
                    passwordRef.current?.focus();
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ paddingTop: "12px" }}>
              <FormTextField
                id="outlined-adornment-password"
                type={showPassword ? "text" : "password"}
                value={password || ""}
                onChange={(e) => setPassword(e.target.value)}
                inputRef={passwordRef}
                onKeyDown={(e) => {
                  if (e.key === KEYBOARD_KEYS.ENTER) {
                    onClickLoginButton();
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                        {showPassword ? (
                          <VisibilityOffIcon style={{ color: "#8a8a8a" }} />
                        ) : (
                          <VisibilityIcon style={{ color: "#8a8a8a" }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                label="Password"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "24px" }}>
          <Button variant="contained" onClick={onClickLoginButton} fullWidth className={styles.loginBtn}>
            Continue
          </Button>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "0" }}>
          <div className={styles.divider}>
            <span className={styles.line} />
            <span className={styles.orText}>Or</span>
            <span className={styles.line} />
          </div>

          <div className={styles.actionButtons}>
            {/* <Button
              variant="outlined"
              className={styles.actionBtn}
              startIcon={<BeenhereIcon className={styles.icon} />}
              onClick={() => navigate(ROUTES.LICENCE_SETUP)}
            >
              Setup Licence
            </Button> */}

            {platform !== "ios" && (
              <Button
                variant="outlined"
                className={styles.actionBtn}
                style={{ width: "100%" }}
                startIcon={<WalletIcon className={styles.icon} />}
                href="https://admin.sanoft.com/pricing"
                target="_blank"
              >
                Purchase
              </Button>
            )}
          </div>

          <div className={styles.support}>
            Need Support?
            <a
              href={`https://wa.me/${CONTACT_NUMBER}`}
              target="_blank"
              rel="noreferrer"
              className={styles.whatsappLink}
            >
              WhatsApp Us
            </a>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default Login;
